export default "__VITE_ASSET__D$h_9ZL5__"